import React from 'react';
import { TimeWithTimeZone, Icon } from '@common/components';
import { StateBadge } from 'works/legacy/components/state-badge';
import { Col, Row } from 'antd';

import {
  COLOR_STYLE_MAP,
  KnownRequestState,
  LABEL_OVERWRITE,
} from 'works/legacy/components/staffing-request-state';

type StaffingRequestStateBadgeProps = {
  state: KnownRequestState;
  timestamp?: string;
  submissionsPaused?: boolean;
  showPausedSubmissionLabel?: boolean;
};

export function StaffingRequestStateBadge({
  state,
  timestamp,
  submissionsPaused,
  showPausedSubmissionLabel,
}: StaffingRequestStateBadgeProps) {
  const isNewSubmissionsPaused = submissionsPaused && state === 'OPEN';

  const statusIcons = (
    <>
      {isNewSubmissionsPaused && (
        <Icon
          icon="doNotEnter"
          color="rubyRed"
          size="sm"
          tooltipText="Not accepting new submissions"
        />
      )}
    </>
  );

  return (
    <Row style={{ display: 'flex', flexWrap: 'nowrap' }}>
      <Col>
        <StateBadge
          state={LABEL_OVERWRITE[state] || state}
          caption={
            timestamp ? (
              <TimeWithTimeZone date={timestamp} variant="long_format" />
            ) : null
          }
          color={COLOR_STYLE_MAP[state]}
          statusIcons={statusIcons}
          statusLabel={
            (showPausedSubmissionLabel &&
              isNewSubmissionsPaused &&
              'Not accepting submissions') ||
            undefined
          }
        />
      </Col>
    </Row>
  );
}
